import styled from 'styled-components';
import { Image, token } from '@zillow/constellation';

export const StyledIconBG = styled.div`
  align-items: center;
  background-color: ${token('colors.aqua500')};
  border-radius: 50%;
  color: ${token('colors.white')};
  display: none;
  height: 32px;
  justify-content: center;
  width: 32px;

  @media screen and (min-width: 992px) {
    display: flex;
  }

  .User-icon {
    position: relative;
    top: -1px;
  }
`;

export const StyledImage = styled(Image)`
  border-radius: 50%;
`;

export const StyledUserIconText = styled.div`
  display: block;

  @media screen and (min-width: 992px) {
    display: none;
  }
`;
